/**
 * Funnel progress as a 0-100 percentage. Provided by FunnelApp, consumed by
 * the `progress` content block — so the progress bar is positioned within the
 * step's block flow (e.g. directly above the question) rather than pinned to
 * the top of the page above the hero content.
 */
import { createContext } from "preact";

export const ProgressContext = createContext<number>(0);
